import {
  RETRIEVAL_GUARDIAN_BOND,
} from "../guardianFormConfig";
import {
  GoogleAutoComplete,
  LabeledCreatableSelect,
  splitEmploymentOccupation,
  joinEmploymentOccupation,
} from "./VABondRetrieveShared";
import RetrievalGuardianFormBase from "./RetrievalGuardianFormBase";

export default function VAGuardianForm(props) {
  return (
    <RetrievalGuardianFormBase
      bondKind={RETRIEVAL_GUARDIAN_BOND.va}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      splitEmploymentOccupation={splitEmploymentOccupation}
      joinEmploymentOccupation={joinEmploymentOccupation}
      {...props}
    />
  );
}
